export default __webpack_public_path__ + "static/media/sv_5.05d66098.webp";